export default __webpack_public_path__ + "assets/webgl/complete-17.41a1aa01.jpg";